var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sky-suffix',_vm._l((_vm.mediaPlatForm),function(item){return _c('i',{key:item.value,staticClass:"icon iconfont",class:[item.iconClass, _vm.hasItem(item) ? 'active' : ''],on:{"click":function($event){return _vm.change(item)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }